import createAxios from './api'

const PATH = 'signatureChains'

export default {
  async createSignatureChain(req) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}`, req)

    return resp.data
  },

  async createMultiSignatureChain(req) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}/multi`, req)

    return resp.data
  },

  async getSignatureChain(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/${id}`)
    return resp.data
  },

  async listMySignatureChains(q, pageRequest) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/self`, {
      params: {
        ...q,
        ...pageRequest
      }
    })

    return resp.data
  },

  async listSignatureChains(q, pageRequest) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}`, {
      params: {
        ...q,
        ...pageRequest
      }
    })

    return resp.data
  },

  async deleteSignatureChain(id) {
    const axios = await createAxios()
    await axios.delete(`${PATH}/${id}`)
  },

  async softDeleteSignatureChain(id) {
    const axios = await createAxios()
    await axios.delete(`${PATH}/soft/${id}`)
  },

  async updateSignatureChain(id, req) {
    const axios = await createAxios()
    await axios.put(`${PATH}/${id}`, { viewerEmails: req })
  },

  async withdrawSignatureChain(id) {
    const axios = await createAxios()
    await axios.put(`${PATH}/withdraw/${id}`)
  },

  async getSignatureChainByExternalId(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/externalId/${id}`)

    return resp
  },

  async resendInvitations(id) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}/${id}/resendInvitations`)

    return resp.data
  }

}
